import React from 'react'
import { DataBlock, FlowGrid } from '@fs/zion-ui'
import { useSlsStateContext, getSlsTypeByValue } from '@fs/zion-sls'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import ReviewDetailsRow from '../../shared/components/ReviewDetailsRow'
import { namePartTypeKeys } from '../../shared/utils/helpers'

/**
 * Displays the Essential Information Review Mode inside a Card component.
 *
 * @component
 * @param {Object} props - Component props
 * @param {Object} props.person - Person object containing essential information
 * @returns {JSX.Element} The rendered DataBlocks with review mode information
 */
const EssentialInformationReview = ({ person }) => {
  const { t } = useTranslation()
  const { types } = useSlsStateContext()

  // Extract names
  const names = person?.subElements?.filter((se) => se.elementType === 'NAME') || []

  return (
    <FlowGrid orientation="vertical" columnCount={1} gutters="xs">
      {names.map((name) => (
        <React.Fragment key={`name-${name.id}`}>
          <DataBlock
            heading={
              getSlsTypeByValue(name?.nameType, 'names', types)?.displayLabel ||
              t('essential-info-name-default', 'Name')
            }
            data={<ReviewDetailsRow person={name} fieldTypesArray={namePartTypeKeys} />}
          />
        </React.Fragment>
      ))}
    </FlowGrid>
  )
}

EssentialInformationReview.propTypes = {
  person: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
}

export default EssentialInformationReview
